import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import css from './index.module.scss';

const I: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');

    return (
        <div id="rapid-pro-I" className={`rapid-pro-I ${css.section}`}>
            <div className="media">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1749009644812/10.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1749009644812/10.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1749884988614/10_M.jpg"
                />
            </div>
            <div className="info sec">
                <p className="info-title">{t('I_title')}</p>
                <p className="info-desc">{t('I_desc')}</p>
            </div>
        </div>
    );
};

export default I;
